export default px => {
  return `${px * 0.063}rem`
}
